export const sleep = (ms: number): Promise<void> => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
};

export const ab2str = (ab: ArrayBuffer): string => {
  const arr = Array.from(new Uint16Array(ab));
  return String.fromCharCode.apply(null, arr);
};

export const encodeBase64 = (text: string): string => {
  const codeUnits = new Uint16Array(text.length);
  for (let i = 0; i < codeUnits.length; i++) {
    codeUnits[i] = text.charCodeAt(i);
  }
  return btoa(String.fromCharCode(...new Uint8Array(codeUnits.buffer)));
};

export const str2ab = (str: string): ArrayBuffer => {
  const buf = new ArrayBuffer(str.length * 2);
  const bufView = new Uint16Array(buf);
  for (let i = 0, strLen = str.length; i < strLen; i += 1) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
};

export const decodeBase64 = (encoded: string): string => {
  const binary = atob(encoded);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < bytes.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return String.fromCharCode(...new Uint16Array(bytes.buffer));
};

export const createControlledPromise = <T>(): [
  Promise<T>,
  (value: T) => void,
] => {
  let resolver: (value: T) => void;
  const promise = new Promise<T>((resolve) => {
    resolver = resolve;
  });
  return [promise, resolver!];
};

export const normalizeWhiteSpace = (str: string) =>
  str.replace(/\s+/g, ' ').trim();

/**
 * Safely parses a value that may be a JSON string or an already-parsed object.
 */
export const safeParseJson = <T = Record<string, unknown>>(
  value: unknown,
): T => {
  if (typeof value === 'string') {
    return JSON.parse(value) as T;
  }
  return value as T;
};
